import React, { useEffect, useState } from "react";
import Aux from "../../hoc/Auxiliary";
import { AlertsTableBig } from "./Alerts";
import axiosConfig from "../../axiosConfig";
import jwt_decode from "jwt-decode";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import PersonIcon from "@material-ui/icons/Person";
import PeopleIcon from "@material-ui/icons/People";
import authgetUser from "../../services/auth.getUser";
import * as alertTypes from "../../shared/language.json";
import { useHistory } from "react-router-dom";

function AssignedAlerts(props) {
  const [assignedAlerts, setAlerts] = useState([]);
  const [initialAlerts, setInitialAlerts] = useState([]);
  const [loggedUser, setLoggedUser] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { pointsStore } = props;


  useEffect(() => {
    axiosConfig.get(
      `/Alarm/AlarmsByStatusIdAndDate?statusId=2`
    ).then((res) => {
      setAlerts(res.data);
      setInitialAlerts(res.data);
      const getTheUser = authgetUser();
      const decodedToken = jwt_decode(getTheUser.accessToken);
      setLoggedUser(decodedToken.Username);
      setIsLoading(false);
    })
      .catch((err) => {
        console.log(err);
      });
  }, [pointsStore]);

  const actions = [
    {
      icon: () => <PersonIcon />,
      tooltip: "Οι Ειδοποιήσεις Μου",
      onClick: () => {
        setAlerts(
          assignedAlerts.filter(function (alarm) {
            return alarm.assignmentUser === loggedUser;
          })
        );
      },
      isFreeAction: true,
    },
    {
      icon: () => <PeopleIcon />,
      tooltip: "Όλες Οι Ειδοποιήσεις",
      onClick: () => {
        setAlerts(initialAlerts);
      },
      isFreeAction: true,
    },
  ];

  const columns = [
    {
      field: "id",
      title: "Αρ. Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "beneficiaryId",
      title: "Κωδ. Ωφελούμενου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmSeverity",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "value",
      title: "Τιμή Ειδοποιήσης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "dateCreated",
      title: alertTypes.LABELS.DATEALERT,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "assignmentDate",
      title: "Ημ/νία Ανάληψης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },

    {
      field: "assignmentUser",
      title: "Χειριστής Αν.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
  ];

  return (
    <Aux>
      <AlertsTableBig
        alerts={assignedAlerts}
        columns={columns}
        title="Ειδοποιήσεις σε Εξέλιξη"
        isLoading={isLoading}
        localPath="asignedAlerts"
      />
    </Aux>
  );
}
const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload, editMapPoint, setter) => {
      dispatch(actions.editMapStateAsync(mapPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignedAlerts);